import { AsyncState } from "./AsyncState";

export class PoolState extends AsyncState {
    pools: any[] = [];
}